module.exports = __webpack_public_path__ + "img/entpark_2.237ae78a.jpg";